// @ts-nocheck
import * as addPanel from '@/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_header'],
      sections: [
        addPanel.sections.getSections().designPanelOnly.headerStyleSection,
      ],
    };
  },
};
